var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrescriptionRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14018_107454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 44,
    height: 44,
    rx: 8,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 45,
    height: 45,
    rx: 8.5,
    stroke: "#F1F1F2",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0181 28.1453C32.0058 28.223 31.0594 28.7844 30.4541 29.6286C30.1741 29.2381 29.8192 28.912 29.4208 28.6625L35.5578 22.5252C36.388 21.6952 36.8452 20.5876 36.8452 19.4064C36.8452 18.225 36.3883 17.1173 35.5578 16.2874C34.7278 15.4571 33.6202 15 32.4387 15C31.2576 15 30.1499 15.4568 29.32 16.2874L18.9534 26.6537C18.1234 27.4836 17.666 28.5913 17.666 29.7727C17.666 30.9541 18.1232 32.0618 18.9534 32.8918C19.8136 33.7519 20.9429 34.1814 22.0725 34.1814C23.0457 34.1814 24.0175 33.8607 24.8178 33.2227C25.1502 34.0037 25.6088 34.6576 25.9172 35.0481C26.9392 36.3421 28.2376 37.5947 29.7777 38.7716C29.9768 38.924 30.2154 39 30.4544 39C30.6931 39 30.9318 38.924 31.1308 38.7719L31.1311 38.7716C32.6709 37.5947 33.9696 36.3421 34.9916 35.0481C35.7116 34.1356 37.2587 31.7907 36.0744 29.7286C35.4666 28.6707 34.2693 28.0456 33.0181 28.1453ZM29.9241 16.8912C30.5928 16.2224 31.4857 15.8542 32.4387 15.8542C33.392 15.8542 34.2849 16.2224 34.9537 16.8912C35.6224 17.56 35.9907 18.4529 35.9907 19.4062C35.9907 20.3592 35.6224 21.2521 34.9537 21.9208L30.0727 26.8023L25.0431 21.7724L29.9241 16.8912ZM19.5575 32.2877C18.1707 30.9009 18.1707 28.6445 19.5575 27.2578L24.4387 22.3765L29.4684 27.4064L28.5937 28.2811C28.365 28.2111 28.1297 28.1638 27.8902 28.1453C26.6418 28.045 25.4413 28.6705 24.8341 29.7289C24.3376 30.5933 24.3242 31.5064 24.5256 32.3435C23.1343 33.6713 20.9243 33.6539 19.5575 32.2877ZM34.3205 34.5187C33.343 35.7568 32.0952 36.9593 30.6122 38.0928C30.5193 38.1643 30.3889 38.1635 30.2966 38.0931C28.8133 36.9596 27.5655 35.757 26.588 34.5187C25.9753 33.7428 24.6504 31.7645 25.5749 30.1544C25.989 29.4335 26.7831 28.9897 27.6353 28.9897C27.6982 28.9897 27.7611 28.9923 27.8244 28.9969C28.752 29.0686 29.6427 29.7197 30.0406 30.6172C30.1089 30.7719 30.2619 30.8715 30.431 30.8715H30.4766C30.6458 30.8715 30.7987 30.7719 30.8671 30.6172C31.265 29.7197 32.1556 29.0684 33.0833 28.9969C34.003 28.9285 34.8882 29.3802 35.3325 30.1541C36.2576 31.7639 34.9329 33.7425 34.3205 34.5187Z",
    fill: "#E17E61",
    stroke: "#E17E61",
    strokeWidth: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14018_107454",
    x: 0,
    y: 0,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14018_107454"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14018_107454",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionRed);
export default __webpack_public_path__ + "static/media/prescriptionRed.e7ade7bdda37d043cc7fa6cd0a24fe71.svg";
export { ForwardRef as ReactComponent };